import {
    CustomComponentProps,
    GeneralColorsVast
} from "utils/types/generalTypes";

export type RadioBtnProps = CustomComponentProps & {
    text?: string;
    name: string;
    color?: GeneralColorsVast | "";
    checked?: boolean;
};

const RadioBtn = ({
    text,
    name,
    color = "is-primary",
    checked = false,
    handleClick,
    className,
    style
}: RadioBtnProps) => {
    return (
        <label className={`material-radio ${color} ${className}`} style={style}>
            <input
                type="radio"
                name={name}
                checked={checked}
                onClick={() => handleClick && handleClick()}
            />
            <span className="dot"></span>
            {text ? <span className="radio-label">{text}</span> : ""}
        </label>
    );
};

export default RadioBtn;
